import React from 'react';
import { Link, Tooltip } from '@mui/material';

// Renders a whatsapp community link as a clickable, truncated anchor.
// A class only carries the links its rule allows, so the other columns are empty.
const CommunityLinkCell = ({ link }) => {
  if (!link) return '-';

  return (
    <Tooltip title={link} placement="top">
      <Link
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{
          display: 'block',
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {link}
      </Link>
    </Tooltip>
  );
};

export default CommunityLinkCell;
